import './AevocamTooltip.css'
import type { ReactElement, ReactNode } from 'react'

type Props = {
  label: ReactNode
  children: ReactElement
}

/** Hover/focus tooltip centered above a toolbar control. */
export function AevocamTooltip({ label, children }: Props) {
  return (
    <span className='AevocamTooltip'>
      {children}
      <span className='Label' role='tooltip'>
        <span className='Content'>{label}</span>
        <span className='Arrow' aria-hidden />
      </span>
    </span>
  )
}
